module.exports = __webpack_public_path__ + "img/background-layers-button.9d2c5e7d.svg";